import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { initGuard } from './init.guard';
import { authGuard } from './auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 't', pathMatch: 'full' },
  // {
  //   path: 'app-status',
  //   loadChildren: (): Promise<any> => import('@idea-ionic/common').then(m => m.IDEAAppStatusPage),
  //   canActivate: [initGuard]
  // },
  {
    path: 'auth',
    loadComponent: () => import('./auth/auth.page').then(m => m.AuthPage),
    canActivate: [initGuard]
  },
  {
    path: 'sign-up',
    loadChildren: () => import('./sign-up/sign-up.routes').then(m => m.routes),
    canActivateChild: [initGuard]
  },
  {
    path: 't',
    loadChildren: () => import('./tabs/tabs.routes').then(m => m.routes),
    canActivate: [initGuard, authGuard]
  },
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  { path: '**', redirectTo: 'auth' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      paramsInheritanceStrategy: 'always',
      bindToComponentInputs: true
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
